import axiosApi from "../axiosInstance";




export async function getApplicationDropdown(request) {
    try {
        const response = await axiosApi.post(`/Application/getApplicationDropdown`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getApplicationDropdown===>:", error);
 return error?.response?.data;
    }
};

export async function getApplicationList(request) {
    try {
        const response = await axiosApi.post(`/Application/GetApplicationList`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getApplicationList===>:", error);
 return error?.response?.data;
    }
};

export async function GetApplicationsByUserId(userId) {
    try {
        let request = {};
        const response = await axiosApi.post(`/Application/GetApplicationsByUserId/${userId}`, request);
        return response?.data?.data;
    } catch (error) {
        console.log('Error GetApplicationsByUserId===>:', error);
 return error?.response?.data;
    }
};

export async function GetAssignedUnAssignedApplicationsByUserId(userId) {
    try {
        let request = {};
        const response = await axiosApi.post(`/Application/GetAssignedUnAssignedApplicationsByUserId/${userId}`, request);
        return response?.data?.data;
    } catch (error) {
        console.log('Error GetApplicationsByUserId===>:', error);
 return error?.response?.data;
    }
};

export async function CreateUserApplicationAccess(request) {
    try {
        const response = await axiosApi.post(`/UserFeature/CreateUserApplicationAccess`, request);
        return response?.data;
    } catch (error) {
        console.log('Error CreateUserApplicationAccess===>:', error);
 return error?.response?.data;
    }
};

const addApplication = async (body) => {
    try {
        const response = await axiosApi.post(`Application/CreateApplication`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addApplication ===>", error);
         return error?.response?.data;
    }
};

export const ApplicationService = {
    getApplicationDropdown,
    getApplicationList,
    GetApplicationsByUserId,
    GetAssignedUnAssignedApplicationsByUserId,
    addApplication,
}
